import { UploadBatchProductionValidationReportResource } from "@models/resource/upload-batch-production-validation-report.resource";
import { UploadBatchProductionValidationReport } from "@models/ui/upload-batch-production-validation-report.model";
import { MapperBase } from "src/app/utilities/mapper-base";

export class UploadBatchProductionValidationReportResourceToUploadBatchProductionValidationReportMapper extends MapperBase<UploadBatchProductionValidationReportResource, UploadBatchProductionValidationReport> {
    map(source: UploadBatchProductionValidationReportResource): UploadBatchProductionValidationReport {
        const dest = new UploadBatchProductionValidationReport();
        dest.missingSourceFileCount = source.missingSourceFileCount;
        dest.missingOriginalFileCount = source.missingOriginalFileCount;
        dest.missingPdfFileCount = source.missingPdfFileCount;
        dest.failedToIndexDocCount = source.failedToIndexDocCount;
        dest.failedToConvertCount = source.failedToConvertCount;
        dest.unsupportedFileTypeThresholdCount = source.unsupportedFileTypeCount;
        dest.pageCountThresholdCount = source.pageCountThresholdCount;
        dest.runReportDateTime = source.runReportDateTime;
        return dest;
    }
}